export default __webpack_public_path__ + "static/media/certificate-body.cc9979de.png";